import { Link } from "react-router-dom";
import ChevronRightIcon from "/public/images/icons/chevronRight.svg?react";
import PropTypes from "prop-types";

export default function BookingCard({ booking }) {
  const formattedDate = new Date(booking?.DateSlot).toLocaleDateString("en-GB");
  const allBookedIn = booking?.AllBookedIn === 1;
  const isCompleted = (booking?.status ?? booking?.Status) === 4;

  const borderClass = isCompleted
    ? "border-slate-400"
    : allBookedIn
    ? "border-green-500"
    : "border-[#E3E3E3]";

  return (
    <Link to={"/bookings/" + booking?.BookingId} state={{ booking }}>
      <div className={`flex flex-row gap-y-4 border justify-between rounded-lg p-6 bg-white ${borderClass}`}>
        <div className="flex flex-col gap-y-2 p-4 justify-center">
          <p className="text-sportsBlue text-[12px] tracking-widest font-semibold">
            {formattedDate} <span>•</span> {booking?.StartTime?.slice(0, 5)}
          </p>
          <p className="text-sportsBlack font-medium">
            {booking?.BookableThingName}
          </p>
          {booking?.InstanceName && (
            <p className="text-sportsDarkGrey text-[13px]">
              {booking.InstanceCount} {booking.InstanceName}
            </p>
          )}
          {booking?.LeadParticipant && (
            <div className="flex items-center gap-2">
              <p className="text-sportsDarkGrey text-[13px]">
                {booking.LeadParticipant}
                {booking?.TotalParticipants > 1 && (
                  <span className="ml-1 text-[11px] font-semibold uppercase tracking-[1.5px] bg-sportsLightGrey rounded-[4px] px-[7px] py-[2px] ml-2">
                    +{booking.TotalParticipants - 1} more
                  </span>
                )}
              </p>
            </div>
          )}
          {isCompleted && (
            <span className="inline-flex items-center gap-1 self-start rounded-full bg-slate-100 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-widest text-slate-500">
              Completed
            </span>
          )}
          {!isCompleted && allBookedIn && (
            <span className="inline-flex items-center gap-1 self-start rounded-full bg-green-50 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-widest text-green-600">
              All Booked In
            </span>
          )}
        </div>
        <div className="flex flex-col justify-center">
          <ChevronRightIcon className="w-6 h-6 fill-black" />
        </div>
      </div>
    </Link>
  );
}

BookingCard.propTypes = {
  booking: PropTypes.shape({
    BookingId: PropTypes.string.isRequired,
    DateSlot: PropTypes.string.isRequired,
    StartTime: PropTypes.string.isRequired,
    BookableThingName: PropTypes.string,
    InstanceName: PropTypes.string,
    InstanceCount: PropTypes.number,
    LeadParticipant: PropTypes.string,
    TotalParticipants: PropTypes.number,
    AllBookedIn: PropTypes.number,
    Status: PropTypes.number,
    status: PropTypes.number,
  }).isRequired,
};
